import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import './index.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Differentiation from './components/Differentiation';
import CourseContent from './components/CourseContent';
import WhoIsFor from './components/WhoIsFor';
import ProductValue from './components/ProductValue';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Terms from './components/Terms';
import Privacy from './components/Privacy';

function App() {
  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const userAgent = navigator.userAgent;

      fetch('https://pilot.mindlink.work/api/oauth-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          finger_print: result.visitorId,
          ua: userAgent,
          components: result.components
        }),
      })
        .then(res => res.json())
        .then(data => {
          console.log('Fingerprint data sent:', data);
        })
        .catch(err => {
          console.error('Failed to send fingerprint:', err);
        });
    };

    loadFingerprint();
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              <Differentiation />
              <CourseContent />
              <WhoIsFor />
              <ProductValue />
              <FAQ />
              <FinalCTA />
            </main>
          } />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
